import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { NavigationLinkProps } from './types';

const baseClassNames =
  'hover:text-white-hover text-white-primary flex items-center px-4 active:bg-clip-text active:text-transparent active:bg-light-gradient-text border-solid border-transparent font-bold cursor-pointer';

export const NavigationLink = ({
  href,
  label,
  onClick,
  asButton,
  external,
  className,
  isActive = false,
  variant = 'desktop',
}: NavigationLinkProps) => {
  const itemClassName = twMerge(
    baseClassNames,
    variant === 'mobile'
      ? 'h-[54px] border-r-2 md:px-6'
      : 'h-[66px] border-b-4 -mb-0.5',
    isActive && 'border-white-primary text-white-primary',
    className
  );
  if (asButton) {
    return (
      <button type="button" onClick={onClick} className={itemClassName}>
        {label}
      </button>
    );
  }

  if (external) {
    return (
      <a
        target="_blank"
        onClick={onClick}
        href={href ?? '#'}
        rel="noopener noreferrer"
        className={itemClassName}
      >
        {label}
      </a>
    );
  }

  return (
    <Link to={href ?? '#'} onClick={onClick} className={itemClassName}>
      {label}
    </Link>
  );
};
